<template>
  <div class="incoming-info-actions">
    <div class="flex-centering">
      <Button size="small" type="ghost" left-icon="excel" @click="importOffer">
        {{ $t('Import offer') }}
      </Button>
      <Button size="small" type="ghost" left-icon="new-page" @click="openTenderPublicPage">
        {{ $t('Public page') }}
      </Button>
      <Button
        v-if="showExportAllButton"
        left-icon="download"
        size="small"
        type="ghost"
        :loading="exportXlsxLoading"
        @click="handleExport"
      >
        {{ $t('Export all offers') }}
      </Button>
    </div>
    <div v-if="get(tenderInfo, 'offers.length', false)" class="offers-filter spacex-8">
      <Switcher
        color="blue"
        size="sm"
        :value="showOldAndArchivedOffers"
        @change="changeShowingOffers"
      />
      <div class="offers-filter__text text-sm grey-900">
        {{ $t('Show') }}
        <Badge color="light-red">
          {{ tenderOfferVersionStatuses['archived'] }}
        </Badge>
        {{ $t('offers') }}
      </div>
    </div>
  </div>
</template>

<script>
  import PlusIcon from '@/assets/icons/plus.svg';
  import NewPageIcon from '@/assets/icons/new-page.svg';
  import CloseIcon from '@/assets/icons/circle-x.svg';
  import { mapActions, mapMutations, mapState } from 'vuex';
  import Switcher from '@/components/ui/Switcher';
  import Badge from '@/components/ui/Badge';
  import editTender from '@/utils/mixins/edit-tender';
  import get from 'lodash.get';
  import DownloadIcon from '@/assets/icons/download.svg';
  import downloadByLink from '@/utils/download-by-link';
  import Button from '@/components/ui-v2/Button';
  import CreateOfferModal from '@/components/tender/CreateOfferModal';
  import { addModule } from '@/store';
  import publicTender from '@/store/public-tender';

  export default {
    name: 'OfferActions',
    components: { Button, Switcher, Badge },
    mixins: [editTender],
    created() {
      addModule('publicTender', publicTender);
    },
    data() {
      return {
        closeIcon: CloseIcon,
        plusIcon: PlusIcon,
        newPageIcon: NewPageIcon,
        downloadIcon: DownloadIcon,
        declineLoading: false,
        createLoading: false,
        exportXlsxLoading: false,
        MIN_OFFERS_COUNT: 1,
      };
    },
    computed: {
      ...mapState('tender', ['tenderInfo', 'showOldAndArchivedOffers', 'tenderOffers']),
      ...mapState('global', ['tenderOfferVersionStatuses']),
      showExportAllButton() {
        return this.tenderInfo?.offers_count > this.MIN_OFFERS_COUNT;
      },
      ...mapState('publicTender', ['showModal']),
    },
    methods: {
      get,
      ...mapMutations('tender', ['changeTender']),
      ...mapActions('alert', ['showAlert']),
      ...mapActions('modal', ['openModal']),
      ...mapActions('publicTender', ['initPublicTenderInfo', 'openExcelModal']),
      handleInvitation() {
        this.editTender(this.tenderInfo.id, 3);
      },
      changeShowingOffers() {
        this.changeTender({
          key: 'showOldAndArchivedOffers',
          value: !this.showOldAndArchivedOffers,
        });
      },
      openTenderPublicPage() {
        let route = this.$router.resolve({
          name: 'public-tender',
          params: { tenderHash: this.tenderInfo.public_link_hash },
        });
        window.open(route.href, '_blank');
      },
      async importOffer() {
        await this.initPublicTenderInfo({
          tenderHash: this.tenderInfo.public_link_hash,
          isPublic: false,
        });
        this.openModal({
          component: CreateOfferModal,
        });
      },
      async handleExport() {
        this.exportXlsxLoading = true;
        const response = await downloadByLink({
          link: `/tenders/${this.tenderInfo.id}/rows/xlsx/`,
          fileName: `${this.tenderInfo.name} - ${this.$t('offers')}.xlsx`,
        });
        if (response instanceof Error) {
          this.showAlert({
            type: 'error',
            text: this.$t('Failed to download Excel file, please try again.'),
          });
        }
        this.exportXlsxLoading = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .incoming-info-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 20px;

    height: 40px;
    background: #ffffff;
    box-shadow: inset 0px -2px 0px #e8ebf0;

    .offers-filter {
      display: flex;

      &__text {
        display: grid;
        align-content: center;
        grid-auto-flow: column;
        grid-column-gap: 4px;
      }
    }
  }
</style>
